import { combineReducers } from 'redux';
import { reducerUser as user } from './ManageUserPage';
import { reducerCredit as credit } from './ManageUserPage';
import { reducerAdminNotes as adminNotes } from './ManageUserPage';
import { reducer as operator } from './ManageAdminPage';
import { reducer as ad } from './ManageAdPage';
import { reducer as report } from './ManageReportPage';
import { reducer as chatReport } from './ManageChatReportPage';
import { reducer as userFeedbacks } from './ManageUserFeedbackPage';
import { reducer as ratings } from './ManageRatingsPage';
import { reducer as phoneVerificationRequests } from './ManagePhoneVerificationPage';
import { reducer as agency } from './ManageAgencyPage';
import { reducer as cart } from './ManageCartPage';
import { reducer as systemMessages } from './ManageSystemMessagesPage';
import { reducer as makeModelInfo } from './ManageMakeModelInfoPage';
import userStatistics from './UserStatisticsPage/userStatistics.ducks';
import global from './reducer';

export const adminReducer = combineReducers({
  global,
  user,
  credit,
  adminNotes,
  cart,
  operator,
  ad,
  report,
  chatReport,
  userFeedbacks,
  ratings,
  phoneVerificationRequests,
  agency,
  systemMessages,
  makeModelInfo,
  userStatistics,
});



// WEBPACK FOOTER //
// ./src/routes/Admin/admin.ducks.ts